'use client';

import dynamic from 'next/dynamic';
import type { HomeComponentMap } from './HomeSectionRenderer';

// 仅供 US 客户端首页的 202 对照组使用，不改变小语种默认注册表。
const CategoryNavBig = dynamic(() => import('./components/CategoryNavBig/CategoryNavBig'), {
  ssr: false,
});
const CategoryNavShape = dynamic(() => import('./components/CategoryNavShape/CategoryNavShape'), {
  ssr: false,
});
const CategoryNavSmall = dynamic(() => import('./components/CategoryNavSmall/CategoryNavSmall'), {
  ssr: false,
});
const FivePicSwiper = dynamic(() => import('./components/FivePicSwiper/FivePicSwiper'), {
  ssr: false,
});
const HeroBanner = dynamic(() => import('./components/HomeBanner/HomeBanner'), {
  ssr: false,
});
const MultiSwipe = dynamic(() => import('./components/MultiSwipe/MultiSwipe'), {
  ssr: false,
});
const OneLineTwo = dynamic(() => import('./components/OneLineTwo/OneLineTwo'), {
  ssr: false,
});
const ProductList = dynamic(() => import('./components/ProductList'), {
  ssr: false,
});
const BlogArticle = dynamic(() => import('./components/BlogArticle/BlogArticle'), {
  ssr: false,
  loading: () => <div className="h-[200px] animate-pulse bg-[#f5f5f5]" />,
});
const BrandImage = dynamic(() => import('./components/BrandImage/BrandImage'), {
  ssr: false,
  loading: () => <div className="h-[100px] animate-pulse bg-[#f5f5f5]" />,
});
const StyleHub = dynamic(() => import('./components/StyleHub/StyleHub'), {
  ssr: false,
  loading: () => <div className="h-[300px] animate-pulse bg-[#f5f5f5]" />,
});
const WaterFall = dynamic(() => import('./components/WaterFall/WaterFall'), {
  ssr: false,
  loading: () => <div className="h-[400px] animate-pulse bg-[#f5f5f5]" />,
});

export const US_WAP_COMPONENT_MAP: HomeComponentMap = {
  swipeImage: HeroBanner,
  categoryNavSmall: CategoryNavSmall,
  categoryNavShape: CategoryNavShape,
  categoryNavBig: CategoryNavBig,
  styleHub: StyleHub,
  multiSwipe: MultiSwipe,
  oneLineTwo: OneLineTwo,
  multiSwipeSecond: FivePicSwiper,
  blogArticle: BlogArticle,
  brandImage: BrandImage,
  regularList: ProductList,
  waterFall: WaterFall,
};
